import { getLocaleByPurchaseCountry } from '@nemuru-eng/js-api-client';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { PAYMENT_INTENT_CONTAINER_ID } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/CheckoutSessionDetail';
import { LenderSelectedData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';
import { usePaymentIntent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/hooks/usePaymentIntent';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';

export const useBnplPaymentIntent = () => {
  const { createPaymentIntent, refreshPaymentMethodEntity, updatePaymentMethodEntity } = usePaymentIntent();
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  const mountPaymentIntent = async (
    paymentMethodDetailEntity: BnplPaymentMethodDetailEntity,
    onClose: () => void,
    onLenderSelected: (data: LenderSelectedData) => void,
  ) => {
    if (!checkoutSessionEntity) {
      throw new Error('Checkout session entity not found');
    }

    if (paymentMethodDetailEntity.shouldCreatePaymentIntent()) {
      throw new Error('Payment intent must be created before mounting');
    }

    const clientSecret = await checkoutSessionEntity.getClientSecret();

    const locale = getLocaleByPurchaseCountry(checkoutSessionEntity.checkoutSession.purchaseCountry);

    paymentMethodDetailEntity.mount({
      queryString: `#${PAYMENT_INTENT_CONTAINER_ID}`,
      clientSecret,
      locale,
      onLenderSelected: (data) => onLenderSelected(data),
      onClose: onClose,
      onError: () => {},
    });
  };

  return {
    createPaymentIntent,
    mountPaymentIntent,
    refreshPaymentMethodEntity,
    updatePaymentMethodEntity,
  };
};
